<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="">
        <!--<img class="navbar-brand-full" src="img/brand/logo.svg" width="89" height="25" alt="Logo">-->
        <img class="navbar-brand-full" src="img/logo.png" width="136" height="20" alt="Earned Value">
        <!--<img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="Logo">-->
        <img class="navbar-brand-minimized" src="img/logo-symbol.png" width="20" height="20" alt="EV">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto">
        <b-nav-item id="getstarted" ref="getstarted">
          <i class="fa fa-question-circle-o"></i>
        </b-nav-item>
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>

      <!--TODO: modal is needed instead of v-bind:show="this.$route.params.id == 'welcome'" in popover, 
      because with v-bind:show extra click is required before click or blur triggers can work, 
      also users can't get to click if ? is covered due to fallback-placement always flip (poppers.js bug)-->

      <b-modal ref="welcome-modal" class="left-text" ok-only title="Get Started in 3 Simple Steps:">
          1. Setup <a href="#/projects">Projects</a>, including <strong>Bill Rates</strong> and <strong>Budget and Progress</strong><br><br>
          2. Enter <a href="#/time">Time</a> and <a href="#/expense">Expense</a><br><br>
          3. Review <a href="#/portfolio">Portfolio</a> and <a href="#/project-reports">Project Reports</a><br><br>
          For integration with other software, please email <a href="mailto:support@earnedvalue.app">support@earnedvalue.app</a> and we can setup at no cost and no obligation to you:<br><br>
		  Project management software:<br><strong>Asana, Basecamp, Jira, Trello, and more</strong><br><br>
		  Time tracking software:<br><strong>Clockify, Harvest, Toggl, and more</strong><br><br>
          For technical assistance, please email <a href="mailto:support@earnedvalue.app">support@earnedvalue.app</a><br><br>
          You can view this message again by clicking "?" at the top
      </b-modal>

      <b-popover target="getstarted" triggers="click blur" placement="leftbottom" title="Get Started in 3 Simple Steps:">
          1. Setup <a href="#/projects">Projects</a>, including <strong>Bill Rates</strong> and <strong>Budget and Progress</strong><br><br>
          2. Enter <a href="#/time">Time</a> and <a href="#/expense">Expense</a><br><br>
          3. Review <a href="#/portfolio">Portfolio</a> and <a href="#/project-reports">Project Reports</a><br><br>
          For integration with other software, please email <a href="mailto:support@earnedvalue.app">support@earnedvalue.app</a> and we can setup at no cost and no obligation to you:<br><br>
		  Project management software:<br><strong>Asana, Basecamp, Jira, Trello, and more</strong><br><br>
		  Time tracking software:<br><strong>Clockify, Harvest, Toggl, and more</strong><br><br>
          For technical assistance, please email <a href="mailto:support@earnedvalue.app">support@earnedvalue.app</a>
      </b-popover>
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <!--<Breadcrumb :list="list"/>-->
        <br>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <!--<DefaultAside/>-->
      </AppAside>
    </div>
    <!--<TheFooter>-->
      <!--footer-->
      <!--
      <div class="ml-auto">
        <span class="mr-1">Copyright &copy; 2018 <a href="http://www.tmetrack.com">TME Track LLC</a> All rights reserved</span>
      </div>
    </TheFooter>
    -->
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js'
import {poolData} from '@/shared/aws-settings'

export default {
  name: 'full',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      nav: nav.items
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  created () {
    var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
    var cognitoUser = userPool.getCurrentUser();
    var vueInstance = this;

    if (cognitoUser != null) {
        cognitoUser.getSession(function(err, session) {
            if (!session.isValid())
              vueInstance.$router.push({name: "Sign In"});

        });
    }
    else
      vueInstance.$router.push({name: "Sign In"});

  },
  mounted () {
    if (this.$route.params.id == 'welcome') {
      this.$refs['welcome-modal'].show()
    }
  }
}
</script>

<style>
  .left-text {text-align: left;}
</style>
